import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            <span className="cyan">Chonkbox Studios</span>{" "}is an independent 
            dev studio powered by caffeine, cat energy, and a love for science-based 
            game design. Right now we're developing 
            {" "}<span className="cyan">Isotonaut</span>, a mobile game about 
            isotope synthesis and discovery.  Our goal is simple: build games 
            that make science fun and intuitive.
            <br />
            <br />More projects{" "}<span className="cyan">(and more chonk)</span>{" "}coming soon.
            <br />
            <br />
            Outside of coding, we love engaging in activities that keep us
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Woodworking 🔨
            </li>
            <li className="about-activity">
              <ImPointRight /> Fishing & Kayaking 🛶
            </li>
          </ul>

          <p style={{ color: "hsl(186, 67%, 29%)" }}>
            "Big ideas in a small box!"{" "}
          </p>
          <footer className="blockquote-footer">Chonkbox Studios</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
